export default __webpack_public_path__ + "static/media/IMG_8258.7fd9c82b.jpeg";